var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.07 114.624C395.607 114.624 425.222 148.864 431.842 194.26H288.297C294.918 148.864 324.532 114.624 360.069 114.624H360.07Z",
    fill: "#D93B43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.92 115.346C400.436 120.482 425.78 152.691 431.842 194.26H305.997C312.059 152.691 337.404 120.482 368.92 115.346Z",
    fill: "#FB545C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M383.172 91.2696C395.957 78.4851 395.957 57.7571 383.172 44.9725C370.388 32.1879 349.66 32.1879 336.875 44.9725C324.091 57.7571 324.091 78.4851 336.875 91.2697C349.66 104.054 370.388 104.054 383.172 91.2696Z",
    fill: "#FFC186"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.92 36.5654C382.7 40.4254 392.806 53.0774 392.806 68.0904C392.806 83.1034 382.7 95.7544 368.92 99.6154C355.14 95.7554 345.033 83.1034 345.033 68.0904C345.033 53.0774 355.14 40.4254 368.92 36.5654Z",
    fill: "#FDD7AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.93 114.623C187.467 114.623 217.082 148.863 223.702 194.259H80.1582C86.7792 148.863 116.393 114.623 151.93 114.623Z",
    fill: "#0E82F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.78 115.346C192.296 120.482 217.64 152.691 223.702 194.26H97.8574C103.919 152.691 129.264 120.482 160.78 115.346Z",
    fill: "#009EF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.712 83.6034C189.3 67.6933 183.365 47.8334 167.455 39.2451C151.544 30.6569 131.685 36.5925 123.096 52.5026C114.508 68.4128 120.444 88.2727 136.354 96.861C152.264 105.449 172.124 99.5136 180.712 83.6034Z",
    fill: "#FFC186"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.781 36.5654C174.561 40.4254 184.668 53.0774 184.668 68.0904C184.668 83.1034 174.562 95.7544 160.781 99.6154C147.001 95.7554 136.894 83.1034 136.894 68.0904C136.894 53.0774 147 40.4254 160.781 36.5654Z",
    fill: "#FDD7AD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.001 114.624C291.538 114.624 321.153 148.864 327.773 194.26H184.228C190.849 148.864 220.463 114.624 256 114.624H256.001Z",
    fill: "#FDC72E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.85 115.346C296.366 120.482 321.71 152.691 327.772 194.26H201.927C207.989 152.691 233.334 120.482 264.85 115.346Z",
    fill: "#FDDB1E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M288.099 74.2266C291.533 56.4757 279.928 39.3016 262.177 35.8672C244.426 32.4328 227.251 44.0387 223.817 61.7897C220.383 79.5407 231.989 96.7148 249.74 100.149C267.491 103.583 284.665 91.9776 288.099 74.2266Z",
    fill: "#FFC186"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.85 36.5654C278.63 40.4254 288.736 53.0774 288.736 68.0904C288.736 83.1034 278.63 95.7544 264.85 99.6154C251.07 95.7554 240.963 83.1034 240.963 68.0904C240.963 53.0774 251.069 40.4254 264.85 36.5654Z",
    fill: "#FDD7AD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.983 383.041L369.596 390.901C379.461 396.597 392.195 393.185 397.891 383.319C403.588 373.452 400.175 360.72 390.309 355.023L318.429 313.524L245.991 264.629L227.652 254.041C213.448 245.842 198.301 243.847 182.461 248.091L138.765 259.799L135.461 258.922L34.8721 330.309L78.8751 356.933C97.5251 382.367 92.2101 377.412 116.704 393.101L232.899 458.343L254.376 449.607L271.579 459.54C280.188 464.51 291.299 461.533 296.27 452.924C301.241 444.314 298.263 433.203 289.654 428.233L308.213 438.948C316.822 443.918 327.933 440.941 332.904 432.332C337.867 423.735 334.885 412.605 326.288 407.641L337.907 414.349C346.516 419.319 357.627 416.343 362.598 407.733C367.569 399.124 364.591 388.013 355.982 383.042L355.983 383.041Z",
    fill: "#FDD7AD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.485 387.95L369.596 390.901L369.619 390.914L364.485 387.95ZM298.398 447.103C299.698 439.817 296.413 432.137 289.661 428.235L294.665 431.124L308.214 438.946L308.23 438.955L294.665 431.123L289.655 428.23L289.661 428.233L246.251 403.17C245.57 402.776 244.819 402.52 244.04 402.416C243.261 402.313 242.469 402.364 241.709 402.566C240.175 402.975 238.866 403.976 238.071 405.35C237.275 406.724 237.058 408.358 237.467 409.892C237.875 411.426 238.877 412.734 240.251 413.53L298.398 447.101V447.103ZM335.029 426.509L263.01 384.929C261.636 384.133 260.635 382.824 260.226 381.29C259.817 379.757 260.034 378.123 260.83 376.749C261.625 375.375 262.934 374.374 264.468 373.965C266.002 373.557 267.636 373.774 269.01 374.569L320.282 404.171L337.916 414.352L337.909 414.348L326.29 407.64C333.035 411.534 336.323 419.225 335.03 426.509H335.029ZM364.726 401.913L284.302 355.48C282.928 354.684 281.927 353.375 281.518 351.841C281.109 350.308 281.326 348.674 282.122 347.3C282.918 345.926 284.226 344.925 285.76 344.516C287.294 344.108 288.928 344.325 290.302 345.12L356.021 383.063C362.751 386.971 366.024 394.639 364.726 401.913Z",
    fill: "#FFC186"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.877 356.933L135.463 258.923L80.158 226.992L10 348.509L65.305 380.44L78.877 356.933Z",
    fill: "#009EF9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.445 303.048L188.755 319.173C193.861 328.016 203.95 332.312 213.777 329.538L285.185 309.378C296.796 306.099 307.978 307.495 318.429 313.525L390.309 355.024C400.174 360.72 403.587 373.453 397.891 383.32L439.298 352.309L376.537 258.923L309.519 248.092C293.679 243.848 278.532 245.84 264.33 254.042L179.445 303.048Z",
    fill: "#FFC186"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M376.526 258.916L431.829 226.986L501.987 348.5L446.684 380.43L376.526 258.916Z",
    fill: "#FB545C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.56 400.18C174.616 392.124 174.616 378.942 166.56 370.886C158.504 362.83 145.322 362.83 137.267 370.886L120.984 387.169C112.928 395.225 112.928 408.407 120.984 416.463C129.04 424.519 142.222 424.519 150.277 416.463L166.56 400.18ZM228.95 439.493L217.23 451.213C211.432 457.011 211.432 466.499 217.23 472.297C223.028 478.095 232.515 478.095 238.314 472.297L250.034 460.577C255.841 454.77 255.823 445.283 250.034 439.493C244.236 433.695 234.748 433.695 228.95 439.493ZM222.988 445.455C229.465 438.978 229.465 428.38 222.988 421.903C216.511 415.426 205.913 415.426 199.436 421.903L186.344 434.995C179.867 441.472 179.867 452.07 186.344 458.547C192.821 465.024 203.419 465.024 209.896 458.547L222.987 445.456L222.988 445.455Z",
    fill: "#FFC186"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.345 434.994L195.87 425.469C203.377 417.962 203.377 405.677 195.87 398.169C188.363 390.661 176.078 390.661 168.571 398.169L153.396 413.344C145.889 420.852 145.889 433.136 153.396 440.644C160.904 448.151 173.188 448.152 180.696 440.644L186.345 434.995V434.994Z",
    fill: "#FFC186"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99219 348.51L23.5642 325.004L78.8672 356.934L65.2962 380.441L9.99219 348.51Z",
    fill: "#0E82F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M433.113 356.926L488.416 324.996L501.988 348.501L446.684 380.431L433.113 356.926Z",
    fill: "#D93B43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV3);
export default __webpack_public_path__ + "static/media/V3.a7b9ca84f7ed85c9b5de4c1e8badf588.svg";
export { ForwardRef as ReactComponent };